import PropertyCardContainer from 'legacy/containers/property-card';
import classNames from 'classnames';

const CompsProperties = ({ addressIds, dataHcNames, compType }) => {
  return (
    <div
      className={classNames('comps-summary--property-list-container', {
        'comps-summary--property-list-container--none-selected':
          addressIds.length === 0
      })}
      data-hc-name={dataHcNames.gallery}
    >
      {addressIds.length > 0 &&
        addressIds.map((addressId, i) => (
          <div
            className="comps-summary--property"
            key={`comp-${i}-${addressId}`}
          >
            <PropertyCardContainer
              addressId={addressId}
              compType={compType}
              PinLabel={i + 1}
              hideSelectControl
              nonLazy
            />
          </div>
        ))}
    </div>
  );
};

export default CompsProperties;
